var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOrderBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#00C8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.196 7.71a1.28 1.28 0 0 0-1.813 0l-.688.686 2.24 2.24.69-.69a1.28 1.28 0 0 0 0-1.811l-.429-.426Zm-6.848 5.033c-.14.14-.247.311-.309.5l-.677 2.033a.552.552 0 0 0 .695.695l2.033-.677c.188-.062.36-.17.501-.309l3.83-3.83-2.244-2.242-3.829 3.83ZM1.333 1.333H10v5.724a.667.667 0 0 0 1.333 0V1.333C11.333.597 10.736 0 10 0H1.333C.597 0 0 .597 0 1.333v12c0 .737.597 1.334 1.333 1.334H5.48a.667.667 0 1 0 0-1.334H1.333v-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.667 4c0-.368.298-.667.666-.667H8a.667.667 0 0 1 0 1.334H3.333A.667.667 0 0 1 2.667 4Zm0 3.333c0-.368.298-.666.666-.666H8A.667.667 0 1 1 8 8H3.333a.667.667 0 0 1-.666-.667Zm0 3.334c0-.368.298-.667.666-.667h3a.667.667 0 0 1 0 1.333h-3a.667.667 0 0 1-.666-.666Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOrderBlueIcon);
export default __webpack_public_path__ + "static/media/edit-order-blue-icon.1c6c8091181a6198b0590e4c54072e33.svg";
export { ForwardRef as ReactComponent };